import React from "react";
import bg_image from "../../assets/images/Packages page Header-01.jpg";
import bg_image_m from "../../assets/images/Packages page Header mobilescreen-01.jpg";

const PackagesBanner = () => {
  return (
   <div className=" w-full xl:bg-fixed relative mx-auto   overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bg_image} alt="" className="w-full  h-auto hidden xl:block  " />
        <img src={bg_image_m} alt="" className="w-full  h-auto  block xl:hidden" />
      </div>
    </div>
  );
};
export default PackagesBanner;


